<template>
  <div id="impersonation-banner">
    <p>Você está navegando como <strong>{{ user.name }} {{ user.last_name }}</strong> ({{ user.email }})</p>
    <button v-if="!isStopping" @click="stopImpersonating">Voltar para o admin</button>
    <SpinnerLoaderButton v-else :height="32" :maxWidth="180"/>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useAxios } from '@/api/axios'
import { user } from '@/global/states/GlobalState'
import SpinnerLoaderButton from '@/components/loader/SpinnerLoaderButton.vue'

const axios = useAxios()
const isStopping = ref(false)

function stopImpersonating () {
  isStopping.value = true

  axios.post('/api/stop-impersonating')
    .then(() => {
      window.location.href = '/platform-admin/dashboard'
    })
    .finally(() => isStopping.value = false)
}
</script>

<style lang="scss">
  #impersonation-banner{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 20px;
    padding: 12px 20px;
    background: #E1793E;
    position: sticky;
    top: 0;
    z-index: 20;
    box-sizing: border-box;
    p{
      color: #FFF;
      font-family: 'Inter', sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      margin: 0;
      text-align: center;
      strong{
        font-weight: 700;
      }
    }
    button{
      height: 32px;
      min-width: 160px;
      padding: 0 16px;
      border-radius: 20px;
      background: #FFF;
      color: #E1793E;
      font-family: 'Inter', sans-serif;
      font-size: 13px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      white-space: nowrap;
      cursor: pointer;
      transition: background .2s;
      &:hover{
        background: #F5F5F5;
      }
    }
  }

  @media(max-width: 600px){
    #impersonation-banner{
      flex-direction: column;
      row-gap: 10px;
    }
  }
</style>
